import React from 'react';
import { Helmet } from 'react-helmet';
import { DEFAULT_TITLE, DEFAULT_DESCRIPTION, SITE_NAME, absoluteUrl } from '../../utils/seo';

/*
Props:
- title: string | undefined
- description: string | undefined
- path: string (route pathname to build canonical) | undefined
- image: string (absolute or relative) | undefined
- noIndex: boolean
*/
const SEO = ({ title, description, path, image, noIndex = false, children }) => {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESCRIPTION;
  const canonical = absoluteUrl(path || (typeof window !== 'undefined' ? window.location.pathname : '/'));
  const ogImage = image ? (image.startsWith('http') ? image : absoluteUrl(image)) : absoluteUrl('/logo512.png');

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={desc} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {/* PWA & misc */}
      <meta name="application-name" content={SITE_NAME} />
      <meta name="apple-mobile-web-app-title" content={SITE_NAME} />

      {children}
    </Helmet>
  );
};

export default SEO;
